import { Input, Directive, forwardRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Directive()
export abstract class InputBase {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() errorMsg = '';
  @Input() name = '';
  @Input() control!: FormControl;
  @Input() disabled = false;
  @Input() shortLabel = '';
  @Input() submitAttempted = false;

  touched = false;


  private readonly submitOnlyErrorKeys = [
    'healthConditionRequired',
    'crimeRequired',
    'refusedVisaRequired',
    'cancelledVisaRequired',
    'otherApplicantsRequired',
    'childrenNotIncludedRequired',
    'workedInRequired',
    'qualificationsRequired',
    'ownershipsRequired',
    'positionsRequired'
  ];


  get showError(): boolean {
    return !!this.control && this.control.invalid && (this.control.touched || this.control.dirty);
  }

  get errorMessages(): string[] {

    var errorLabel = this.capitalizeFirstLetter(this.shortLabel || this.label);

    if (!this.control || !this.control.errors) return [];

    const errors: string[] = [];
    const err = this.control.errors;

    const hasSubmitOnlyError =
      !this.submitAttempted &&
      this.submitOnlyErrorKeys.some(errorKey => !!err[errorKey]);

    if (hasSubmitOnlyError) {
      return [];
    }

    if (err['required']) errors.push(this.errorMsg || `${errorLabel} is required`);
    if (err['minlength']) errors.push(`${errorLabel} must be at least ${err['minlength'].requiredLength} characters`);
    if (err['maxlength']) errors.push(`${errorLabel} must be at most ${err['maxlength'].requiredLength} characters`);
    if (err['abnMaxLength']) errors.push(`${errorLabel} must be at most ${err['abnMaxLength'].maxLength} characters`);
    if (err['email']) errors.push(`Please enter a valid email address`);
    if (err['pattern']) errors.push(`${errorLabel} format is invalid`);
    if (err['mustBeYes']) errors.push('Please select Yes to continue');
    if( err['healthConditionRequired'] && this.submitAttempted) errors.push(`At least one health condition must be added`);
    if( err['crimeRequired'] && this.submitAttempted) errors.push(`At least one crime must be added`);
    if( err['refusedVisaRequired'] && this.submitAttempted) errors.push(`At least one refused visa must be added`);
    if( err['cancelledVisaRequired'] && this.submitAttempted) errors.push(`At least one cancelled visa must be added`);
    if( err['otherApplicantsRequired'] && this.submitAttempted) errors.push(`At least one other applicant must be added`);
    if( err['childrenNotIncludedRequired'] && this.submitAttempted) errors.push(`At least one non-included child must be added`);
    if( err['workedInRequired'] && this.submitAttempted) errors.push(`At least one employment history entry must be added`);
    if( err['qualificationsRequired'] && this.submitAttempted) errors.push(`At least one qualification must be added`);
    if( err['ownershipsRequired'] && this.submitAttempted) errors.push(`At least one business must be added`);
    if( err['positionsRequired'] && this.submitAttempted) errors.push(`At least one position must be added`);
    if( err['mustMatch']) errors.push(`Emails do not match`);
    if (err['passwordPattern']) errors.push(`Password does not meet the requirements. It must contain: <ul><li>1 number</li><li>1 lowercase letter</li><li>1 capital letter</li><li>8-50 characters</li></ul>`);
    return errors.length ? errors : [this.errorMsg || `${errorLabel} is invalid`];
  }
   

  getShortLabel(): string {
    return this.shortLabel || this.label;
  }

  private capitalizeFirstLetter(value: string): string {
    if (!value) return value;

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  get isRequired(): boolean {
  return this.control?.hasValidator(Validators.required) || false;
}


}
